import React, { useState } from 'react';
import './RestaurantsCard.css';
import { useNavigate } from 'react-router-dom';
import translations from '../../constants/translations.json';
import { useDataContext } from '../../context/data';
import { venueSellsOnline } from '../../utils/orderTypes';

const DEFAULT_IMG =
  'https://res.cloudinary.com/burgerkingnorway/image/upload/v1674745616/Heywaitr/1674745616-images.png';

const RestaurantsCard = ({ restaurant, isFavorite }) => {
  const { setOrderFromRestaurantsNotAllowed, language } = useDataContext();
  // Ordering paused (subscription blocked) shows as closed; the menu still opens.
  const isOpen =
    restaurant.status === 'Open' && venueSellsOnline(restaurant) && !restaurant.orderingPaused;
  const navigate = useNavigate();

  return (
    <div
      className="restaurants-card w-full max-w-[450px] md:max-w-full cursor-pointer rounded-3xl bg-white shadow-md hover:shadow-xl transition-shadow duration-100 overflow-hidden"
      onClick={() => {
        if (!venueSellsOnline(restaurant)) {
          setOrderFromRestaurantsNotAllowed(true);
          return;
        }

        navigate(`/restaurants/${restaurant.id}`);
      }}
    >
      {/* Image Section */}
      <div className="relative">
        <img
          src={restaurant.coverimage || DEFAULT_IMG}
          alt="restaurant image"
          className="w-full h-44 object-cover"
        />
        <p
          className={`restaurants-card-status absolute top-3 right-2 px-7 py-2 text-sm text-white font-semibold rounded-full ${
            !isOpen && 'closed'
          }`}
        >
          {isOpen
            ? translations[language]?.restaurant_open
            : translations[language]?.restaurant_closed}
        </p>
      </div>

      {/* Content Section */}
      <div className="p-6 pt-4 sm:p-8 sm:pt-6">
        <div className="flex justify-between items-center mb-4">
          <p className="mr-2 text-lg md:text-xl font-bold cursor-pointer text-gray-800">
            {restaurant.name}
          </p>
          <button
            className="text-blue-500 hover:text-blue-700 focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <i
              className={`${
                isFavorite ? 'fas' : 'far'
              } fa-star text-yellow-400 hover:text-yellow-600`}
            />
          </button>
        </div>

        <div className="flex items-start gap-3">
          <div className="flex justify-center items-center min-w-9 min-h-9 bg-gray-100 rounded-full">
            <i className="fas fa-map-marker-alt text-gray-600" />
          </div>
          <div>
            <p className="text-sm text-primary">
              {restaurant.distance} {translations[language]?.restaurant_from_you}
            </p>
            <p className="text-sm text-gray-500">{restaurant.address}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantsCard;
